import { render, staticRenderFns } from "./FixedAssets.vue?vue&type=template&id=5e876998&scoped=true"
import script from "./FixedAssets.vue?vue&type=script&lang=js"
export * from "./FixedAssets.vue?vue&type=script&lang=js"
import style0 from "./FixedAssets.vue?vue&type=style&index=0&id=5e876998&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e876998",
  null
  
)

export default component.exports